import { render, staticRenderFns } from "./servicManagement.vue?vue&type=template&id=497fb316&scoped=true&"
import script from "./servicManagement.vue?vue&type=script&lang=js&"
export * from "./servicManagement.vue?vue&type=script&lang=js&"
import style0 from "./servicManagement.vue?vue&type=style&index=0&id=497fb316&lang=scss&scoped=true&"
import style1 from "./servicManagement.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497fb316",
  null
  
)

export default component.exports